import QuestionAnswer from './QuestionAnswer.vue';
import TrueFalse from '@/components/typo3-library-overrides/common/iaelements/TrueFalse.vue';
import MatchQuestionAndAnswer from '@/components/typo3-library-overrides/common/iaelements/MatchQuestionAndAnswer.vue';
import Comparison from '@/components/typo3-library-overrides/common/iaelements/Comparison.vue';
import TipsCoupon from '@/components/typo3-library-overrides/common/iaelements/TipsCoupon.vue';
import MemoryGame from '@/components/typo3-library-overrides/common/iaelements/MemoryGame.vue';
import Default from '@/components/typo3-library-overrides/common/iaelements/Default.vue';

export default {
  TrueFalse,
  MatchQuestionAndAnswer,
  Comparison,
  TipsCoupon,
  QuestionAnswer,
  MemoryGame,
  Default
};
